import { SEARCH_VISIT_REPORT_START, SEARCH_VISIT_REPORT_SUCCESS, SEARCH_VISIT_REPORT_ERROR, CLEAR_SEARCH_VISIT_REPORT } from '../../appRedux/actions/visitReportAction';
// import { UPDATE_VISIT_RADIOLOGIST_ERROR, UPDATE_VISIT_RADIOLOGIST_START, UPDATE_VISIT_RADIOLOGIST_SUCCESS } from '../../actions/admin/visitReportsAction';

const INIT_STATE = {
    error: "",
    loading: false,
    submitting: false,
    message: '',
    visitReport: {}
}

export default (state = INIT_STATE, action) => {
    let newVisitReport;
    switch (action.type) {
        case SEARCH_VISIT_REPORT_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case SEARCH_VISIT_REPORT_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, visitReport: action.visitReport };

        }
        case SEARCH_VISIT_REPORT_ERROR: {
            return { ...state, error: action.error, message: '', loading: false, visitReport: {} };
        }
        case CLEAR_SEARCH_VISIT_REPORT: {
            return { ...state, error: '', message: '', loading: false, visitReport: {} };
        }
        // case UPDATE_VISIT_RADIOLOGIST_START: {
        //     return { ...state };
        // }
        // case UPDATE_VISIT_RADIOLOGIST_SUCCESS: {
        //     newVisitReport = { ...state.visitReport, ...action.visitReport };
        //     return { ...state, visitReport: {...newVisitReport} };
        // }
        // case UPDATE_VISIT_RADIOLOGIST_ERROR: {
        //     return { ...state };
        // }
        default:
            return state;
    }
}